<template>
  <div class="jade-button-group">
    <div
      class="jade-button-group__desktop"
      :class="computedClass"
    >
      <slot size="medium" />
    </div>
    <div
      class="jade-button-group__mobile"
      :class="computedClass"
    >
      <slot size="larger" />
    </div>
  </div>
</template>

<script>
import DIRECTION_ENUM from '../enums/direction.enum'
import ResizeMixin from '../utils/resize.mixin'

export default {
  name: 'JadeButtonGroup',
  mixins: [ResizeMixin],

  props: {
    direction: {
      type: String,
      validations: v => Object.values(DIRECTION_ENUM).includes(v)
    },
    expanded: Boolean
  },

  computed: {
    computedOrientation () {
      return this.direction || this.isMediumScreen
        ? DIRECTION_ENUM.HORIZONTAL
        : DIRECTION_ENUM.VERTICAL
    },
    computedClass () {
      return {
        'is-expanded':
          this.expanded || this.computedOrientation === DIRECTION_ENUM.VERTICAL,
        [`is-${this.computedOrientation}`]: this.computedOrientation
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/button-group.css';
</style>
